import React from "react";

const StatisticBoxes = () => {
  const stats = [
    { value: "10K+", label: "Assignments Delivered" },
    { value: "98%", label: "On-Time Delivery" },
    { value: "30%", label: "Client Referrals" },
    { value: "99%", label: "Average Rating" },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto px-4 mt-12">
      <div className="grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-4">
        {stats.map((stat, index) => (
          <div key={index} className="w-full flex justify-center">
            <div className="w-full max-w-[200px] min-h-[150px] bg-slate-800 text-white p-4 sm:p-6 rounded-lg border-2 border-dashed border-blue-900 transform transition duration-300 hover:-translate-y-1 hover:shadow-xl flex flex-col justify-center items-center">
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold mb-1 sm:mb-2">
                {stat.value}
              </div>
              <div className="text-orange-500 text-xs md:text-sm font-medium text-center">
                {stat.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatisticBoxes;
